import OBase from './OBase';
import * as Geometry from '../geometry';

export default class Area extends OBase {
  update () {
    let inputGeom = this.getSurfaceObjectInput('Geometry');

    let outputArea = this.getGenericObjectOutput('Area');
    let outputCentroid = this.getGenericObjectOutput('Centroid');

    let outAreaTree = new Geometry.DataTree();
    let outCentroidTree = new Geometry.DataTree();
    if (inputGeom !== null && inputGeom.branchCount() > 0) {
      for (let m = 0; m < inputGeom.branches.length; m++) {
        for (let s = 0; s < inputGeom.branches[m].length; s++) {
          let totalArea = 0.0;
          let totalCentroid = new THREE.Vector3(0, 0, 0);
          const geom = inputGeom.branches[m][s];
          if (geom instanceof Geometry.GHGeometry) {
            const { faces, vertices } = geom;
            faces.forEach(face => {
              const va = vertices[face.a];
              const vb = vertices[face.b];
              const vc = vertices[face.c];
              const ab = (new THREE.Vector3()).subVectors(vb, va);
              const ac = (new THREE.Vector3()).subVectors(vc, va);
              totalArea += Math.abs(0.5 * ab.length() * ac.length() * Math.sin(ab.angleTo(ac)));
            });
          } else {
            for (let i = 0; i < geom.length; i++) {
              let surfacePath = geom[i];

              let area = 0.0;
              let centroid = new THREE.Vector3(0, 0, 0);
              let j = surfacePath.length - 1;
              let ptcount = 0;
              for (let n = 0; n < surfacePath.length; n++) {
                let pt1 = new THREE.Vector3(surfacePath[j].X, surfacePath[j].Y, 0);
                let pt2 = new THREE.Vector3(surfacePath[n].X, surfacePath[n].Y, 0);
                let dist = pt1.distanceTo(pt2);
                let divlen = dist / 0.1;
                for (let k = 0; k < divlen; k++) {
                  let dir1 = new THREE.Vector3();
                  dir1.copy(pt2);
                  dir1.sub(pt1);
                  dir1.normalize();
                  dir1.multiplyScalar(k / divlen * dist);
                  let ptd1 = new THREE.Vector3();
                  ptd1.copy(pt1);
                  ptd1.add(dir1);

                  centroid.add(ptd1);
                  ptcount += 1;
                }
                area += (surfacePath[j].X + surfacePath[n].X) * (surfacePath[j].Y - surfacePath[n].Y);
                j = n;
              }
              centroid.divideScalar(ptcount);
              area *= -1;

              let tempCentroid = new THREE.Vector3(0, 0, 0);
              tempCentroid.copy(centroid);
              tempCentroid.multiplyScalar(area);
              totalArea += area;
              totalCentroid.add(tempCentroid);
            }
            totalArea = totalArea / 2.0;
            totalCentroid.divideScalar(totalArea);
          }

          outAreaTree.add(totalArea, inputGeom.paths[m]);
          outCentroidTree.add(totalCentroid, inputGeom.paths[m]);
        }
      }
    } else {
      outAreaTree.add(0, new Geometry.GHPath(0));
      outCentroidTree.add(new THREE.Vector3(0, 0, 0), new Geometry.GHPath(0));
    }

    outputArea.value = outAreaTree;
    outputCentroid.value = outCentroidTree;
  }
}



// WEBPACK FOOTER //
// ./src/assets/javascripts/gh/components/Area.js